import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import {
  getStoreWarehouseQrCodeByStatus,
} from "../../services/warehouse/StoreWarehouse";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ProgressSpinner } from "primereact/progressspinner";
import { addStoreExternalWarehouseChallanQrcode } from "../../services/StoreExternalWarehouse/StoreExternalWarehouse";

const StoreExternalWarehouseQrCode = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();

  const storeId = storeData.id;
  const location = useLocation();
  const {item} = location.state || {}; // Fallback to prevent undefined errors

  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState(null);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);

  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);

  let qrCodeMap = new Map();
  const fetchData = (data) => {
    getStoreWarehouseQrCodeByStatus(storeId, data)
      .then((response) => {
        if (!response.data.error) {
            response.data.forEach(element => {
                let garmentInfo = {
                  garment: element.garment,
                  id: element.id,
                };
                qrCodeMap.set(element.qrcode, garmentInfo);
              });
          setQrCodes(qrCodeMap);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

   

  useEffect(() => {
    const data = {
      status: ["IN_PROCESS"],
    };
    fetchData(data);
  }, []);

  const handleScan = ({ data }) => {
    if (data) {
      // Ensure data exists
      if (qrCodes.has(data) && !selectedQrCodesChecked.includes(data)) {
        let scannedData = {
            garment: qrCodes.get(data).garment,
            qrcode: data,
            id: qrCodes.get(data).id,
          };       
        setSelectedQrCodes([...selectedQrCodes, scannedData]);
        setDataProvider([...selectedQrCodes, scannedData]);
        setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
      } else {
        console.error(`Data ${data} already exists in the scannedQrArray.`);
      }
    } else {
      console.error("Scanned QR data is null or undefined");
    }
  };
 

  useEffect(() => {
    if (!searchTerm) {
      setDataProviderSuggestion([]);
    } else {
      const suggestions = [];
      qrCodes.forEach((garment, qrCode) => {
        if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
          suggestions.push({ qrCode, garment });
        }
      });

      setDataProviderSuggestion(suggestions);
    }
  }, [searchTerm]);

  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes.forEach((garment, qrCode) => {
      if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({ qrCode, garment });
      }
    });

    const newQrCodes = suggestions.filter(
      (item) => !selectedQrCodesChecked.includes(item.qrCode)
    );

    const updatedSelectedQrCodes = [
        ...selectedQrCodes,
        ...newQrCodes.map(item => ({
          garment: item.garment.garment,
          id: item.garment.id,
          qrcode: item.qrCode,
        })),
      ];
  
    setSelectedQrCodes(updatedSelectedQrCodes);
    setDataProvider(updatedSelectedQrCodes);

    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map((item) => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
  };

  const removeTag = (data) => {
    const updatedTag = selectedQrCodes.filter(
      (item) => item.qrcode !== data.qrcode
    );
    setSelectedQrCodes(updatedTag);
    setDataProvider(updatedTag);
    setSelectedQrCodesChecked(
      selectedQrCodesChecked.filter((code) => code !== data.qrcode)
    );
  };

  const handleRemoveAllSelectedData = () => {
    // Clear all selected QR codes and checked items
    setSelectedQrCodes([]);
    setSearchTerm("");
    setSelectedQrCodesChecked([]);

    // Reset the dataProvider to an empty state
    setDataProvider([]);

    // Optionally, reset the suggestions dataProvider
    setDataProviderSuggestion([]);
  };

  const handleSendToWarehouse = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);      
      const data = {
        qrCodeIds: selectedQrCodes.map(qr => qr.id),
      };

      addStoreExternalWarehouseChallanQrcode(item.id, data)
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;
                const message = Res.message;
                const success = Res.status;
                if (success === true) {
                  setModalVisible(true);
                  setModalStatus('success');
                  setModalText(message);
                  setTimeout(() => {
                    navigate('/StoreExternalWarehouseChallan');
                  }, 1500);
                  setIsSendButtonPressed(false);
                } else {
                  setModalVisible(true);
                  setModalStatus('not Success');
                  setModalText(message);
                  setIsSendButtonPressed(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
              setIsSendButtonPressed(false);
            });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrcode}</p>
        <p className="flex-1 text-lg font-normal ">
          {(item.garment.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garment + "").length > 20 ? "..." : ""}
        </p>
        <div
          onClick={() => removeTag(item)}
          className="flex-1 text-lg font-normal text-right cursor-pointer"
        >
          <img
            src={
              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
            }
            style={{ width: "10%" }}
          />
        </div>
      </div>
    ));
  };

  const renderSearchedTagItem = () => {
    return dataProviderSuggestion?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrCode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrCode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
          <p className="flex-1 text-lg font-normal ">
          {(item.garment.garment.replace(/_/g, ' ') + '').substring(0, 20)}
          {(item.garment.garment + '').length > 20 ? '...' : ''}
          </p>

          <div className="flex-1 text-lg font-normal text-right">
            <div>
              {isSelected ? (
                <img
                  src={
                    "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                  }
                  style={{ width: "10%" }}
                />
              ) : (
                <img
                  src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                  style={{ width: "10%" }}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  const handleBackButton = () => {
    navigate("/StoreExternalWarehouseChallan");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Challan Tags
              </p>
            </div>
             
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex-1 flex flex-column justify-content-center align-items-center">
          <ProgressSpinner />

          <p
            style={{
              color: "#000",
              fontSize: 20,
              fontWeight: "700",
              alignSelf: "center",
            }}
          >
            Garment List is Loading...
          </p>
        </div>
      ) : (
        <div className="flex flex-1 ">
          <div className="flex-1">
            {!loading && (
              <div className="flex-1" style={{pointerEvents: isSendButtonPressed  ? "none" : "auto"}}>
                <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                  <div className=" flex flex-1">
                    <IconField iconPosition="left" className="flex flex-1">
                      <InputIcon className="pi pi-search text-xl"> </InputIcon>
                      <InputText
                        placeholder="Enter Invoice No."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="text-xl flex flex-1 py-1 px-5"
                        style={{ borderRadius: 30 }}
                      />
                    </IconField>
                  </div>
                  {dataProviderSuggestion?.length > 0 && (
                    <div
                      className="flex justify-content-center align-items-center cursor-pointer"
                      onClick={handleSelectAllSearchedData}
                    >
                      <img
                        src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                        style={{ width: "50%" }}
                      />
                    </div>
                  )}
                </div>
                {dataProviderSuggestion?.length !== 0 ? (
                  <div style={{pointerEvents: isSendButtonPressed ? "none" : "auto"}}>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedTagItem()}
                    </div>
                  </div>
                ) : (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Search Tag
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className=" flex-1 surface-0"
            style={{
              "--surface-0": "#f2f2f2",
            }}
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Selected Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div style={{pointerEvents: isSendButtonPressed ? "none" : "auto"}}>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "65vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div className="my-1 mx-2">
                 

                <div className="flex-1 mx-2 mb-1 mt-3 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center" style={{pointerEvents: isSendButtonPressed ? "none" : "auto"}}>
                    <Button
                      onClick={handleSendToWarehouse}
                      disabled={
                        isSendButtonPressed
                      }
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                      {isSendButtonPressed ? 'Adding...' : 'Add To Challan'}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                      <i
              className="pi pi-shopping-cart"
              style={{ fontSize: "27px", color: "#fff" }}
            ></i>
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreExternalWarehouseQrCode;
